import type { Uuid } from '@/types/models/tree'
import { v4 as uuid } from 'uuid'
import { computed, ref } from 'vue'

export type ToastVariant = 'neutral' | 'success' | 'error' | 'warning'

export type Toast = {
  variant: ToastVariant
  content: string
  id: Uuid
}

export const useNotificationStore = defineStore('notification', () => {
  const notifications = ref<Toast[]>([])

  function addNotification(variant: ToastVariant, content: string, duration = 5000) {
    const id = uuid()
    const newToast: Toast = { variant, content, id }

    notifications.value.push(newToast)

    setTimeout(removeNotification, duration, id)
  }

  function removeNotification(id: string) {
    notifications.value = notifications.value.filter(toast => toast.id !== id)
  }

  const allNotifications = computed(() => notifications.value)

  return {
    notifications: allNotifications,
    addNotification,
    removeNotification,
  }
})
